import { render } from "./ResetPasswordForm.vue?vue&type=template&id=4e8f557e&scoped=true&bindings={\"email\":\"data\",\"resetPasswordFormWasValidated\":\"data\",\"newPassword\":\"data\",\"newPasswordAgain\":\"data\",\"token\":\"data\",\"verifyToken\":\"options\",\"postResetPassword\":\"options\"}"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js"

import "./ResetPasswordForm.vue?vue&type=style&index=0&id=4e8f557e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e8f557e"

export default script